/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserDto = {
    id: string;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
    position: string | null;
    onboarding_step: UserDto.onboarding_step;
};
export namespace UserDto {
    export enum onboarding_step {
        USER_DATA = 'USER_DATA',
        FINISHED = 'FINISHED',
    }
}

